var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgListedproducts = function SvgListedproducts(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03213 7.99992H5.62963L6.8148 9.33325H9.1852L10.3704 7.99992H13.9574H2.03213ZM4.47301 3.66005L2.18628 7.51892C2.06434 7.72465 2 7.95945 2 8.19865V11.3333C2 12.0697 2.59695 12.6666 3.33333 12.6666H12.6667C13.4031 12.6666 14 12.0697 14 11.3333V8.19865C14 7.95945 13.9357 7.72465 13.8137 7.51892L11.527 3.66005C11.4069 3.45747 11.1889 3.33325 10.9535 3.33325H5.04653C4.81106 3.33325 4.59305 3.45747 4.47301 3.66005Z",
    stroke: "#227EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListedproducts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/listedproducts.24508ad5.svg";
export { ForwardRef as ReactComponent };